const Goals = () => {
   return (
      <div className="main-text">
         <h5>Goals</h5>
         <p>
            Chambray authentic truffaut, kickstarter brunch taxidermy vape
            heirloom four dollar toast raclette shoreditch church-key. Poutine
            etsy tote bag, cred fingerstache leggings cornhole everyday carry
            blog gastropub. Brunch biodiesel sartorial mlkshk swag, mixtape
            hashtag marfa readymade direct trade man braid cold-pressed roof
            party. Small batch adaptogen coloring book heirloom. Letterpress
            food truck hammock literally hell of wolf beard adaptogen everyday
            carry. Dreamcatcher pitchfork yuccie, banh mi salvia venmo photo
            booth quinoa chicharrones.
         </p>
      </div>
   );
};
export default Goals;
